import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'progressCharts',
    label: 'Progress Charts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
